const features = [
    {
        title: "Learn & Earn",
        description: "Earn SKT tokens while you study through our unique reward system. Engage with content, participate in tutoring, and complete courses to gain financial independence.",
        icone: "/icones/doc.png",
    },
    {
        title: "Mentorship Programs",
        description: "Connect with experienced mentors for personalized guidance and support.",
        icone: "/icones/help.png",
    },
    {
        title: "Authentic certifications",
        description: "Obtain secure and authentic digital certifications powered by blockchain technology. These certifications ensure the credibility of your skills and achievements, making them easily verifiable by employers worldwide.",
        icone: "/icones/event.png",
    },
    {
        title: "Job Matching Services",
        description: "Discover job opportunities and connect with potential employers through our advanced matching algorithms.",
        icone: "/icones/rate.png",
    }
    
]

const featuresDetails = [
    {
        title: "Sign Up and ",
        titleColor_1 :"",
        titleColor_2:"Explore",
        description: "Create your free account on Studycool to start exploring a diverse range of courses and training programs tailored to your interests and specialties. Our platform offers a variety of educational resources, including tutorials, interactive lessons, and mentorship programs. This ensures that every student, regardless of their background, can find something valuable to enhance their learning.",
        image: "/images/signup.svg",
        points : [
           

        ],
        rev:"-reverse"
    },
    {
        title: "Learning Platform",
        titleColor_1:"Decentralized",
        titleColor_2:"",
        description: "Studycool operates on SKOLANA, a layer 2 blockchain built on Solana, which ensures secure and decentralized interactions. This allows students from anywhere in the world to access the platform securely and efficiently. Our decentralized setup breaks down geographical barriers, providing quality education to students regardless of their location. Whether you're in a remote village or a bustling city, you can access the same high-quality educational resources.",
        image: "/images/decent.svg",
        points : [
        ],
       

    },
    {
        title: "System",
        titleColor_1:"Earn & Learn ",
        titleColor_2:"",
        description: "One of the standout features of Studycool is the Earn & Learn system. Through active participation on the platform, students can earn SKT tokens, our native cryptocurrency. Engage with educational content, participate in tutoring sessions, and complete courses to earn these tokens. This unique reward system encourages continuous learning and provides financial independence, making education not just accessible but also economically beneficial.",
        image: "/images/coin.svg",
        points : [
        ],
        rev:"-reverse"

    },
    {
        title: " and ",
        titleColor_1:"Create",
        titleColor_2:"Share",
        description: "Not only can you learn on Studycool, but you can also contribute by creating and offering your own courses and content on the platform. This feature fosters a collaborative and enriching learning environment, where students can benefit from diverse perspectives and expertise. Whether you are an expert in a particular field or a student with valuable knowledge to share, Studycool provides a platform to reach a global audience.",
        image: "/images/share.svg",
        points : [
        ],

    },
    {
        title: "with  ",
        titleColor_1:"Job Matching",
        titleColor_2:"Verified Credentials",
        description: "Our advanced recommendation algorithms connect students with recruiters, matching the right skills to the right opportunities. The NFT certificates reassure employers of the authenticity and competency of our students, facilitating seamless hiring processes. This system ensures that students are not only well-educated but also well-placed in the job market, bridging the gap between education and employment.",
        image: "/images/job.svg",
        points : [
        ],
        rev:"-reverse"
    },
]

const whys = [
    {
        title: "Security",
        description: "Studycool uses blockchain technology to ensure unmatched security and privacy. Unlike traditional social platforms, Studycool guarantees that your data remains private and protected through decentralization, eliminating the risks associated with central points of failure.",
        icone: "/icones/sec.png",
    },
    {
        title: "Transparency",
        description: "With Studycool, every transaction and interaction on the network is recorded on the blockchain, providing complete transparency. This feature allows users to verify the authenticity and integrity of the information shared, enhancing trust within the academic community.",
        icone: "/icones/trans.png",
    },
    {
        title: "Ownership",
        description: "Studycool gives users control over their content and data. Thanks to the decentralized nature of Web3, students have full ownership of their creations and contributions, unlike centralized platforms where content can be exploited without the users' explicit consent.",
        icone: "/icones/prop.png",
    },
    {
        title: "Rewards",
        description: "Studycool innovates by rewarding students' contributions and engagement on the platform. Using token or cryptocurrency systems, students can receive tangible incentives for their active participation, knowledge sharing, and collaboration, fostering a more dynamic and supportive academic community.",
        icone: "/icones/rewar.png",
    },
]

const teams = [
    {
        title: "CEO",
        name :"Amine KEBOUCHE",
        description: "Apprentice Data Engineer at Credit Agricole, with a MIAGE (Computer Methods Applied to Business Management) education from Paris Dauphine University, combining computer science and accounting. I will graduate with a degree in Computer Methods Applied to Business Management.",
        icone: "/images/ceo.jpeg",
    },
    {
        title: "CTO",
        name :"Adnane CHEJJARI",
        description: "Full-stack developer with 7 years of experience, currently working at Orange. Specialized in web development, expert in both front-end and back-end technologies, driving technical innovation within our company.",
        icone: "/images/cto.jpeg",
    },
    {
        title: "CPO",
        name :"Boukhalfa HAMITOUCHE",
        description: "backend developer, and a DevOps with two years of experience at Docaposte. His technical expertise, coupled with his product vision, enables him to transform challenges into opportunities and drive our product forward. Additionally, his experience as an Amazon FBA seller gives him a deep understanding of e-commerce dynamics.",
        icone: "/images/cpo.jpeg",
    },
    {
        title: "Développeuse",
        name :"Kamelia TERKMANI",
        description: "Front-end developer at Jellyfish. Combines expertise in business intelligence with a passion for development. With a strong background in Full Stack development, uses technical skills to transform challenges into innovative solutions, driving projects to excellence.",
        icone: "/images/dev.jpeg",
    },
]


const partners = [
    {
        "description": "Joined the PSL Pépite network in June 2023, Studycool benefits from contacts, equipment, coworking spaces, and personalized support. All the necessary resources to achieve significant milestones in its development!",
        "icone": "/images/pslpepite.png"
    },
    {
        "description": "In September 2023, Studycool entered a pre-incubation phase with the House of Entrepreneurship. It benefits from extensive support and a wide network of experts and investors.",
        "icone": "/images/hoe.png"
    },
    {
        "description": "In February 2024, Studycool participated in the Fighters program at Station F, receiving coaching on business planning and marketing strategies.",
        "icone": "/images/sf.png"
    },
    {
        "description": "In March 2024, our team participated in the H-W3B 2023 hackathon organized by Sia Partners. We developed and presented our MVP, received feedback from juries and participants, and expanded our network.",
        "icone": "/images/w3b.jpg"
    },
    {
        "description": "In April 2024, our team participated in the Paris Blockchain Week, showcasing our MVP using the Solana blockchain.",
        "icone": "/images/pbw.png"
    }
];


export {features, featuresDetails, whys ,teams, partners};